import { X } from 'lucide-react';
import { useState } from 'react';

interface QuantitySelectionModalProps {
    isOpen: boolean;
    onClose: () => void;
    item: {
        id: string;
        displayName: string;
        price: number;
        currency: string;
        payType: string;
        payTypeDisplay?: string | null;
    };
    onConfirm: (quantity: number) => void;
}

export function QuantitySelectionModal({ isOpen, onClose, item, onConfirm }: QuantitySelectionModalProps) {
    const [quantity, setQuantity] = useState(1);

    if (!isOpen) return null;

    const period = item.payTypeDisplay || (item.payType === 'ANUAL' ? 'anual' : 'mensual');

    return (
        <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
            onClick={onClose}
        >
            <div
                className="bg-white text-gray-900 rounded-lg p-6 max-w-md w-full shadow-xl"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold">Cantidad de mails</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <X size={20} />
                    </button>
                </div>

                <div className="mb-6">
                    <div className="relative">
                        <select
                            value={quantity}
                            onChange={(e) => setQuantity(Number(e.target.value))}
                            className="w-full appearance-none bg-white border border-blue-500 text-gray-900 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-3 pr-8 shadow-sm"
                        >
                            {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                                <option key={num} value={num}>
                                    {num} {num === 1 ? 'Mail' : 'Mails'} : ${item.currency} {(item.price * num).toFixed(2)} - {period}
                                </option>
                            ))}
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                            </svg>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-full font-medium transition-colors"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={() => onConfirm(quantity)}
                        className="px-6 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-full font-medium transition-colors"
                    >
                        Continuar
                    </button>
                </div>
            </div>
        </div>
    );
}
